export default __webpack_public_path__ + "static/media/india-country.71755dd5.png";